import { defaultDarkModeOverride } from '@aws-amplify/ui-react'

export const telebinoidTheme = {
  name: 'telebinoid-theme',
  overrides: [defaultDarkModeOverride],
}
